import ipfsClient from 'ipfs-http-client';

var bufferToArrayBuffer = require('buffer-to-arraybuffer');
var xhr = new XMLHttpRequest();
const IPFS_ADDRESS = '/ip4/3.17.26.249/tcp/4001/ipfs/QmeQRpfSrYcAaqkhNoArDyTUwyYiru2gJp4WY1WegQGjtR';
const TIMEOUT = 20000;
const END = [85,110,105,118,101,114,115,97,108,32,83,101,113,101,117,110,99,101,115 ]

const LOCAL = 'LOCAL';
const UNIVERSAL = 'UNIVERSAL';
const INFURA = 'INFURA';

window.httpV = 'http://www.zequencer.io:5001';
window.httpsV = 'https://www.zequencer.io:5002';
class IpfsClient {
    restart() {
        // do nothing since it doesnt even matter -_-
    }

    getIPFSPrefix() {
        if (this.connectedLocally) {
            return 'http://localhost:5001';
        } else if (window.location.protocol === 'http:') {
            return window.httpV;
        } else if (window.location.protocol === 'https:') {
            return window.httpsV;
        }
    }

    getHashUrl(hash) {
        if (this.connectedLocally) {
            return 'http://localhost:8080/ipfs/' + hash;
        } else if (window.location.protocol === 'http:') {
            return '/ipfs/' + hash;
        } else {
            return '/ipfs/' + hash;
        }
    }

    async getPinnedHashes() {
        let list = await this.ipfs.refs.local();
        return list.map(x => x.ref);
    }

    constructor() {
        this.controllers = new Set();
        if (window.isNFT) {
            return;
        }
        if (window.location.protocol === 'http:') {
            this.backupIpfs = new ipfsClient('ipfs.infura.io', '5001', {protocol: 'https'});
            if (window.isNFT) {
                this.centralIpfs = this.backupIpfs;
            } else {
                this.centralIpfs = ipfsClient('www.zequencer.io', '5001', {protocol: 'http'});
            }
        } else {
            if (window.isNFT) {
                this.centralIpfs = this.backupIpfs;
            } else {
                this.centralIpfs = ipfsClient('www.zequencer.io', '5002', {protocol: 'https'});
            }
        }

        this.ipfs = this.centralIpfs;

        let self = this;
        this.connectedLocally = false;
        this.finishedTestingLocalConnection = false;
        xhr.onreadystatechange = () => {
            if (xhr.readyState == 4) {
                // Request finished; either succesful or via timeout
                if (xhr.status == 200) {
                    self.ipfs = ipfsClient('localhost', '5001', {protocol: 'http'})  
                    self.connectToCentral();
                    self.connectedLocally = true;
                    self.finishedTestingLocalConnection = true;
                    this.keepSwarmConnectionAlive();
                }
            }
        };

        if (!window.isNFT) {
            xhr.open("POST", "http://localhost:5001/api/v0/swarm/peers", true);
            xhr.timeout = 4000; // Set timeout to 4 seconds (4000 milliseconds)
            xhr.ontimeout = function () {
                console.log('timed out connecting to local ipfs daemon');
            };
        }

        setTimeout(() => {
            this.finishedTestingLocalConnection = true;
        }, 4000);
        xhr.send("");
    }

    findProvs(hash) {
        return new Promise((resolve, reject) => {
            this.ipfs.dht.findprovs(hash, {maxNumProviders: 1}, (err, res) => {
                resolve(res);
            });
        });
    }

    connectToCentral() {
        try {
                this.ipfs.swarm.connect(IPFS_ADDRESS, (err, res) => {
                })
                    .catch(e => console.log('error'));
            } catch (e) {
                console.log('error connecting to ipfs');
            }
    }

    keepSwarmConnectionAlive() {
        try {
            this.ipfs.swarm.connect(IPFS_ADDRESS, (err, res) => {
            })
                .catch(e => console.log('error'));
        } catch (e) {
            console.log('error connecting to ipfs');
        }
        setInterval(() => {
            if (window.sequencerEngine && window.sequencerEngine.getSequenceId) {
                let id = window.sequencerEngine.getSequenceId();
                if (window.sequencerEngine.store.getState().sequencer.isPlaying[id]) {
                    return;
                }
            }
            try {
                this.ipfs.swarm.connect(IPFS_ADDRESS, (err, res) => {
                })
                    .catch(e => console.log('error'));
            } catch (e) {
                console.log('error connecting to ipfs');
            }
        }, 60000);
    }

    isConnectedLocally() {
        return this.connectedLocally;
    }

    addArrayBuffer(arrayBuffer, id) {
        let self = this;
        return this.addHelper(arrayBuffer, id);
    }

    addArrayBufferAndSaveToDB(arrayBuffer, id) {
        return this.addBlobAndSaveToDB(new Blob([new Uint8Array(arrayBuffer)]), id);
    }

    addHelper(arrayBuffer, id=0, name) {
        if (name === undefined) {
            name = 'hello';
        } 
        let self = this;
        return new Promise((resolve, reject) => {
            self.ipfs.add({name: name, path:'hello', content: new Buffer(arrayBuffer)}, (err, ipfsHash) => {

                console.log("IPFS HASH = ", ipfsHash);
                let hash = ipfsHash[0].hash;
                if (err) {
                    reject(err);
                } else {
                    resolve(hash);
                }
            }); 
        });
    }

    addJson(json, location=LOCAL) {
        return new Promise((resolve, reject) => {
            let ipfsObject = location === UNIVERSAL ? this.centralIpfs :
                location === LOCAL ? this.ipfs : this.backupIpfs;
            ipfsObject.add({path:'sequence', content: Buffer.from(JSON.stringify(json), 'utf8')}, (err, ipfsHash) => {
                if (err) {
                    reject(err);
                } else {
                    let hash = ipfsHash[0].hash;
                    ipfsObject.pin.add(hash);

                    resolve(hash);
                }
            });

            if (location === LOCAL) {
                // add to other IPFS nodes for redundancy
                if (ipfsObject !== this.centralIpfs) {
                    this.addJson(json, UNIVERSAL)
                        .then((hash) => resolve(hash));
                }
                this.addJson(json, INFURA)
                    .then((hash) => resolve(hash));
            }
        });
    }

    getJson(ipfsPath, useCentral=false, timeout=10000, isBytes=false) {
        this.restart();
        return new Promise((resolve, reject) => {
            if (isBytes) {
                this.ipfs.cat(ipfsPath, function (err, file) {
                    resolve(JSON.parse(file.toString('utf8')));
                });
                return;
            }
            let url = "/api/v0/cat?arg=" + ipfsPath;
            let ipfs = useCentral ? this.centralIpfs : this.ipfs;
            let controller = new AbortController();
            this.controllers.add(controller);
            let signal = controller.signal;
            setTimeout(() => {
                controller.abort();
                this.controllers.delete(controller);
                reject();
            }, timeout);

            let method = 'POST';
            let _url = this.getIPFSPrefix() + url;
            if (window.isNFT) {
                method = 'GET';
                _url = ipfsPath;
                fetch(
                    _url,
                    {signal,
                     method
                    })
                    .then(async (resp) => {
                        console.log(resp);
                        let json = await resp.json();
                        console.log("json =", json);
                        resolve(json);
                    });
                return;
            }

            if (window.isNFT) {
                return resolve({});
            }

            fetch(_url,
                  {
                      signal,
                      method
                  })
                .then(async (response) => {
                    this.readAllChunks(response.body).then(
                        ret => {
                            let merged = this.mergeArrays(ret, 0, false);
                            let str = new TextDecoder().decode(merged); 
                            resolve(JSON.parse(str));
                        });
                });
        });
    }

    async addBytesArray(bytesArray) {
        let b = new Uint8Array(bytesArray.length + END.length);
        b.set(bytesArray, 0);
        b.set(END, bytesArray.length);
        let hash = await this.addHelper(b.buffer);
        this.ipfs.pin.add(hash);
        return hash;
    }

    async pin(x) {
        return await this.ipfs.pin.add(x);
    }

    addBlob(blob, name) {
        this.restart();
        return new Promise((resolve, reject) => {
            let arrayBuffer;
            let fileReader = new FileReader();
            let self = this;
            fileReader.onload = function() {
                arrayBuffer = this.result;
                self.addHelper(arrayBuffer, undefined, name)
                    .then(hash => {
                        if (this.connectedLocally) {
                            self.ipfs.pin.add(hash);
                        }
                        self.centralIpfs.pin.add(hash);
                    
                        resolve(hash);
                    })
                    .catch(err => reject(err));
            };
            fileReader.readAsArrayBuffer(blob);
        });
    }

    addBlobAndSaveToDB(blob, id) {
    }

    converttoarraybuffer(blob) {
        return new Promise((resolve, reject) => {
            let arraybuffer;
            let filereader = new filereader();
            let self = this;
            filereader.onload = function() {
                resolve(this.result);
            };
            filereader.readasarraybuffer(blob);
        });
    }

    readAllChunks(readableStream) {
        const reader = readableStream.getReader();
        const chunks = [];
        
        function pump() {
            return reader.read().then(({ value, done }) => {
                if (done) {
                    return chunks;
                }
                chunks.push(value);
                return pump();
            });
        }
        
        return pump();
    }

    getSound(hash, timeout=TIMEOUT) {
        return new Promise((resolve, reject) => {
            let controller = new AbortController();
            this.controllers.add(controller);
            let signal = controller.signal;
            setTimeout(() => {
                controller.abort();
                this.controllers.delete(controller);
                reject();
            }, timeout);

            let method = 'POST';
            let _url = this.getIPFSPrefix() + '/api/v0/get?arg=' + hash + '&stream-channels=true';
            if (window.isNFT) {
                method = 'GET';
                _url = hash;
                return fetch(
                    _url,
                    {signal,
                     method
                    })
                    .then(async (resp) => {
                        console.log('resp =', resp);
                        let json = await resp.arrayBuffer();
                        console.log("arraybuffer =", json);
                        resolve(new Uint8Array(json));
                    });
            }

            if (window.isNFT) {
                return resolve([]);
            }

            fetch(_url,
                  {signal,
                   method
                  })
                .then(async (response) => {
                    this.readAllChunks(response.body).then(
                        ret => {
                            let merged = this.mergeArrays(ret);
                            resolve(merged);
                        })
                        .catch(err => console.log('error reading chunks'));
                })
                .catch(err => {
                    console.log('aborted');
                });
        });
    }

    arrayToBuffer(array) {
        var buffer = new ArrayBuffer(array.length);

        array.map(function(value, i){buffer[i] = value});
        return buffer;
    }

    cancel() {
        console.log('cancelling = ', this.controllers);
        Array.from(this.controllers).forEach(
            x => x.abort());
        // this.controllers = new Set();
    }

    mergeArrays(arrays, skip=512, skipEnd=true) {
        let size = 0;
        for (let i in arrays) {
            size += arrays[i].length;
        }

        let array = new Uint8Array(size - skip);
        let count = 0;
        for (let i in arrays) {
            if (count === 0) {
                array.set(arrays[i].subarray(skip), count);
                count += arrays[i].length - skip;
            } else {
                array.set(arrays[i], count);
                count += arrays[i].length;
            }
        }

        if (!skipEnd) {
            return array;
        }

        let a = array; //array.slice(0, array.length - (1024));
        let offset = this.findEnd(a, END);
        if (offset !== -1) {
            let x = a.slice(0, offset);
            return x;
        }
        return array.slice(0, array.length - (1024));;
    }

    findEnd(array, ending) {
        let index = array.length - 1600;
        let iter = array.slice(index).values();
        let foundIndex = 0;
        for (let i=index; i < array.length; i++) {
            let value = iter.next().value;
            if (value === ending[foundIndex]) {
                if (foundIndex == 0) {
                    index = i;
                }
                foundIndex++;
                if (foundIndex === ending.length - 1) {
                    return index;
                }
            } else {
                foundIndex=0;
                index=i;
            }

        }
        return -1;
    }

    getAudioBuffer(hash, context) {
        this.restart();
        return new Promise((resolve, reject) => {
            this.getSound(hash)
                .then(blob => 
                      context.decodeAudioData(bufferToArrayBuffer(blob), function(buffer) {
                          resolve(buffer);
                      }, function (y, d, e) { if (e) { reject(e); }}))
                .catch(err => {
                    reject(err);
                });
        });
    }
}

const ipfs = new IpfsClient();

export default ipfs;
